import { RepeatedTimeRange as RepeatedTimeRangeDomain } from "@iventis/domain-model/model/repeatedTimeRange";

export interface MapObjectRepeatedTimeRangeValue {
    id: string;
    name: string;
    startDate: number | null;
    endDate: number | null;
    startTime: number | null;
    endTime: number | null;
}

export interface RepeatedTimeRange extends Omit<RepeatedTimeRangeDomain, "startDate" | "endDate" | "startTime" | "endTime"> {
    startTime: string | null;
    endTime: string | null;
    startDate: string | null;
    endDate: string | null;
}
